/**
 * FillErrorNotice — the explicit fail-fast face of a narrative fill error.
 * We never silently drop a failed section: the destructive frame states the
 * failure plainly and shows the raw error verbatim (monospace) for diagnosis.
 */
export function FillErrorNotice({ error }: { error: string }) {
  return (
    <div className="rounded-lg border border-destructive/40 bg-destructive/5 p-3 text-sm break-inside-avoid">
      <p className="font-medium text-destructive">This section failed to render.</p>
      <p className="mt-1 font-mono text-xs leading-relaxed text-muted-foreground">{error}</p>
    </div>
  )
}
